import {loadable} from 'router/routes';
import CMSUtils from 'utils/cms';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import {Page} from './utils';

const Legal = loadable(() => import('legal/Legal'));

Legal.getInitialState = async ({state, cookies, params: {slug}}) => ({
    ...state,
    searchRequest: {
        ...searchRequestInitialState,
        pageType: Page.LEGAL,
    },
    page: await CMSUtils.getPageData({
        cookies,
        slug,
        customType: 'consumer-page-legal',
    }),
});

export default Legal;
